import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IEmployeeDiscount } from "src/models/Offers/EmployeeDiscount.models";

interface EmployeeDiscountState {
  employeeDiscounts: IEmployeeDiscount[];
  employeeDiscountToEdit: IEmployeeDiscount | null;
}

const initialState: EmployeeDiscountState = {
  employeeDiscounts: [],
  employeeDiscountToEdit: null,
};

const employeeDiscountSlice = createSlice({
  name: "EmployeeDiscount",
  initialState,
  reducers: {
    setEmployeeDiscountList: (
      state,
      action: PayloadAction<IEmployeeDiscount[]>
    ) => {
      state.employeeDiscounts = action.payload;
    },
    concatListEmployeeDiscount: (
      state: EmployeeDiscountState,
      action: PayloadAction<IEmployeeDiscount[]>
    ) => {
      state.employeeDiscounts = [
        ...state.employeeDiscounts.concat(action.payload),
      ];
    },
    setEmployeeDiscountToEdit: (
      state,
      action: PayloadAction<IEmployeeDiscount | null>
    ) => {
      state.employeeDiscountToEdit = action.payload;
    },
    addEmployeeDiscount: (state, action: PayloadAction<IEmployeeDiscount>) => {
      state.employeeDiscounts.push(action.payload);
    },
    updateEmployeeDiscount: (
      state,
      action: PayloadAction<IEmployeeDiscount>
    ) => {
      let itemIndex = state.employeeDiscounts.findIndex(
        item => item.employeeDiscountId === action.payload.employeeDiscountId
      );
      if (itemIndex !== -1) state.employeeDiscounts[itemIndex] = action.payload;
    },
    deleteEmployeeDiscount: (state, action: PayloadAction<number>) => {
      const newArray = state.employeeDiscounts.filter(
        item => item.employeeDiscountId !== action.payload
      );
      state.employeeDiscounts = newArray;
    },
  },
});

export const {
  setEmployeeDiscountList,
  concatListEmployeeDiscount,
  setEmployeeDiscountToEdit,
  addEmployeeDiscount,
  updateEmployeeDiscount,
  deleteEmployeeDiscount,
} = employeeDiscountSlice.actions;

export default employeeDiscountSlice.reducer;
